export type ProductLine = 'Material handling';
export type CustomerType = 'Byrnecut' | 'Pucobre';
export type Site = 'Golden Grove' | 'Pucobre';
export type ProductFamily = 'Minetruck';
export type ProductModel = 'MT65';

export const countryList = ['Australia', 'Chile'];

export const customerList: CustomerType[] = ['Byrnecut', 'Pucobre'];

export const site: Site[] = ['Golden Grove', 'Pucobre'];

export const productLine: ProductLine[] = ['Material handling'];

export const productFamily: ProductFamily[] = ['Minetruck'];

export const productModel: ProductModel[] = ['MT65'];

export const assetNames = [
  '8997632100',
  '8997636600',
  '8997674300',
  '8997677600',
  '8997909900',
  '8997863600',
  '8997777300',
  '8997882800',
];

export interface IndividualAsset {
  country: string;
  customer: CustomerType;
  site: Site;
  product_line: ProductLine;
  product_family: ProductFamily;
  product_model: ProductModel;
  asset: string;
}

// export const assetData: IndividualAsset[] = assetNames.map((assetName) => {
//   return {
//     country: 'Australia',
//     customer: 'Byrnecut',
//     product_line: 'Golden Grove',
//     product_line: 'Material handling',
//     product_family: 'Minetruck',
//     asset: assetName,
//   };
// });

export const assetData: IndividualAsset[] = [
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997632100',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997636600',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997674300',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997677600',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997909900',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997863600',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997777300',
  },
  {
    country: 'Australia',
    customer: 'Byrnecut',
    site: 'Golden Grove',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: '8997882800',
  },
  {
    country: 'Chile',
    customer: 'Pucobre',
    site: 'Pucobre',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: 'MT12',
  },
  {
    country: 'Chile',
    customer: 'Pucobre',
    site: 'Pucobre',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: 'MT14',
  },
  {
    country: 'Chile',
    customer: 'Pucobre',
    site: 'Pucobre',
    product_line: 'Material handling',
    product_family: 'Minetruck',
    product_model: 'MT65',
    asset: 'MT20',
  },
];
